import React, { Component } from 'react';
import { Button } from '@mui/material';
import Sidebar from '../sidebar/sidebar';
import CustomerHeader from '../CustomersInfoRelatedLoans/CustomerHeader/Customerheader';
import Customerfilter from '../CustomersInfoRelatedLoans/CustomerFilter/Customerfilter';
import AllCustomerCardview from '../CustomersInfoRelatedLoans/AllCustomerCardView/AllCustomerCardview';
import AllCustomerListview from './CustomersListView/AllCustomerListView/AllCustomerListView';
import DueCustomerCardview from './DueCustomers/DueCustomer';
import DueCustomerListview from './CustomersListView/DueCustomerListView/DueCustomerListView';
import OverdueCustomerCardview from './OverdueCustomers/OverdueCustomer';
import OverdueCustomerListview from './CustomersListView/OverdueCustomerListView/OverdueCustomerListView';
import ClosedCustomerCardview from './ClosedCustomerCardView/ClosedCustomerCardView';
import ClosedCustomerListview from './CustomersListView/ClosedCustomerListView/ClosedCustomerListView';
import CancelledCustomerCardView from './CancelledCustomer/CancelledCustomer';
import CancelledCustomerListView from './CustomersListView/CancelledCustomerListView/CancelledCustomerListView';

class Customer extends Component {

    constructor(props) {
        super(props);
        this.state = {
          listdispl:"",
          opendata:[],
          closedata:[],
          canceldata:[],
          duedata:[],
          overduedata:[],
          alldata:[],
          loading: true,
          counts: {},
          page: 1,
          pageSize: 100,
          totalPages: 1,
          totalRecords: 0
       };
       this.handleView = this.handleView.bind(this)
       this.handlecardView = this.handlecardView.bind(this)
       this.openhandle = this.openhandle.bind(this)
       this.closehandle = this.closehandle.bind(this)
       this.cancelhandle = this.cancelhandle.bind(this)
       this.duehandle = this.duehandle.bind(this)
       this.overduehandle = this.overduehandle.bind(this)
       this.allhandle = this.allhandle.bind(this)
       this.handlePrevious = this.handlePrevious.bind(this)
       this.handleNext = this.handleNext.bind(this)
       this.handlePageChange = this.handlePageChange.bind(this)
    }
    _switchPart(Filter){
        switch(Filter) {
            case 'duecustomer' :
              return  (<DueCustomerCardview list={this.state.listdispl} dueData={this.state.duedata}/>)
            case 'overduecustomer':
              return  (<OverdueCustomerCardview list={this.state.listdispl} overdueData={this.state.overduedata}/>)
              case 'customer':
              return  (<AllCustomerCardview list={this.state.listdispl} allData={this.state.alldata} loading={this.state.loading} AllView={this.allhandle} />)
              case 'closedcustomer' :
              return  (<ClosedCustomerCardview list={this.state.listdispl} closeData={this.state.closedata} CloseView={this.closehandle} />)
            case 'newcustomer':
              return  (<CancelledCustomerCardView list={this.state.listdispl} cancelData={this.state.canceldata} CancelView={this.cancelhandle}/>)
            default:
              return  (<AllCustomerCardview list={this.state.listdispl} allData={this.state.alldata} loading={this.state.loading} AllView={this.allhandle}/>)
              // case 'duecustomerlist' :
              //   return  <DueCustomerListview/>
              // case 'overduecustomerlist':
              //   return  <OverdueCustomerListview/>
              //   case 'customerlist':
              //   return  <AllCustomerListview/>
              //   case 'closedcustomerlist' :
              //   return  <ClosedCustomerListview/>
              // case 'newcustomerlist':
              //   return  <NewCustomerListView/>
              // default:
              //   return  <AllCustomerCardview/>
        }
    }

    handleView() {
      alert("list")
      this.setState({
        listdispl:"list"
      })
    }
    handlecardView(){
      alert("card")
      this.setState({
        listdispl:"card"
      })
    }
    openhandle(val) {
      const data = typeof val === 'object' ? val.data : val;
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        opendata: data,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }
    closehandle(val) {
      const data = typeof val === 'object' ? val.data : val;
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        closedata: data,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }
    cancelhandle(val) {
      const data = typeof val === 'object' ? val.data : val;
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        canceldata: data,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }
    duehandle(val) {
      const data = typeof val === 'object' ? val.data : val;
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        duedata: data,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }
    overduehandle(val) {
      const data = typeof val === 'object' ? val.data : val;
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        overduedata: data,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }
    allhandle(val) {
      const counts = (typeof val === 'object' ? val.counts : {}) || {};
      this.setState({
        alldata: val?.data,
        loading: val?.loading,
        counts,
        page: val?.page || 1,
        pageSize: val?.pageSize || this.state.pageSize,
        totalPages: val?.totalPages || 1,
        totalRecords: val?.totalRecords || 0
      })
    }

    handlePrevious() {
      if (this.state.page > 1) {
        this.setState((prevState) => ({ page: prevState.page - 1 }));
      }
    }

    handleNext() {
      if (this.state.page < this.state.totalPages) {
        this.setState((prevState) => ({ page: prevState.page + 1 }));
      }
    }

    handlePageChange(page) {
      if (page !== this.state.page) {
        this.setState({ page });
      }
    }

    getVisiblePages() {
      const { page, totalPages } = this.state;
      const delta = 2;
      const pages = [];

      for (let i = Math.max(1, page - delta); i <= Math.min(totalPages, page + delta); i++) {
        pages.push(i);
      }

      return pages;
    }

    render(){

        return(
            <div>
            <CustomerHeader
              listView={this.handleView}
              cardView={this.handlecardView}
              OpenView={this.openhandle}
              CloseView={this.closehandle}
              CancelView={this.cancelhandle}
              DueView={this.duehandle}
              OverdueView={this.overduehandle}
              AllView={this.allhandle}
              currentPage={this.state.page}
              pageSize={this.state.pageSize}
              onPageChange={this.handlePageChange}
            />
            {/* <Customerfilter/> */}
            <div>
            <div>
                {this._switchPart(this.props.match.params.filter)}
            </div>
            <div>
              {this.state.totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px', gap: '8px' }}>
                  <Button variant="outlined" onClick={this.handlePrevious} disabled={this.state.page === 1}>
                    Previous
                  </Button>

                  {this.getVisiblePages().map((pageNumber) => (
                    <Button
                      key={pageNumber}
                      variant={this.state.page === pageNumber ? 'contained' : 'outlined'}
                      onClick={() => this.handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </Button>
                  ))}

                  <Button variant="outlined" onClick={this.handleNext} disabled={this.state.page === this.state.totalPages}>
                    Next
                  </Button>
                </div>
              )}
            </div>
            </div>
            <Sidebar/>
            </div>         
        )
    }
}
export default Customer;